module.exports = __webpack_public_path__ + "img/adventure_thumbnail-400x300.682b8929.jpg";